import { getItemUid } from 'entities/CatalogItem/lib/getItemUid';
import { getCustomListCatalogItem } from 'entities/CustomList';

import type { MappedCatalogItem } from 'entities/CatalogItem/model/types/CatalogItemSchema';
import type { CustomListItem } from 'entities/CustomList';
import type { CatalogIdentity } from 'shared/lib/contexts/CatalogIdentityContext';

export interface ListOrderCoverage {
    allItemsOnOrder: boolean;
}

export const emptyListOrderCoverage = (): ListOrderCoverage => ({
    allItemsOnOrder: false,
});

export const getListOrderCoverage = (
    listItems: CustomListItem[],
    selectedItems: Record<string, Partial<MappedCatalogItem>> | undefined,
    identity: CatalogIdentity,
): ListOrderCoverage => {
    const quantities = listItems.flatMap((listItem) => {
        const catalogItem = getCustomListCatalogItem(listItem);
        if (!catalogItem) {
            return [];
        }

        const selectionKey = getItemUid(catalogItem, identity);
        return [selectedItems?.[selectionKey]?.qty ?? 0];
    });

    if (quantities.length === 0) {
        return emptyListOrderCoverage();
    }

    return {
        allItemsOnOrder: quantities.every((qty) => qty > 0),
    };
};
